import { render, staticRenderFns } from "./showHeader.vue?vue&type=template&id=7188cc5a"
import script from "./showHeader.vue?vue&type=script&lang=js"
export * from "./showHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports